import { render, staticRenderFns } from "./BannerListMobileView.vue?vue&type=template&id=3f5d5f96&scoped=true&"
import script from "./BannerListMobileView.vue?vue&type=script&lang=js&"
export * from "./BannerListMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5d5f96",
  null
  
)

export default component.exports